
const home = {
  hero: {
    title: 'Deriway 为出海企业提供一站式支付聚合与收单服务',
    subtitle: '覆盖东南亚、中亚、土耳其、俄罗斯、中东、非洲、拉美等地区与多支付方式',
    description: '专业的跨境支付解决方案，助力企业全球化发展，提供安全、高效、合规的金融服务体验。',
    cta: '立即开始',
    learnMore: '了解更多'
  },
  stats: {
    countries: '覆盖国家',
    transactions: '日交易量',
    uptime: '系统稳定性',
    support: '客户支持'
  },
  features: {
    title: '为什么选择 Deriway',
    subtitle: '专业的金融科技解决方案，为您的业务保驾护航',
    items: [
      {
        title: '全球覆盖',
        description: '支持全球200+国家和地区，覆盖主流支付方式'
      },
      {
        title: '安全合规',
        description: 'PCI DSS认证，符合各国监管要求，资金安全有保障'
      },
      {
        title: '快速接入',
        description: '简单API接入，7x24小时技术支持，快速上线'
      },
      {
        title: '智能风控',
        description: 'AI驱动的风险管理系统，实时监控交易安全'
      }
    ]
  },
  solutions: {
    title: '解决方案',
    subtitle: '针对不同行业和场景的专业解决方案',
    items: [
      {
        title: '电商支付',
        description: '为跨境电商提供完整的支付解决方案'
      },
      {
        title: '游戏充值',
        description: '游戏行业专属的充值和结算服务'
      },
      {
        title: '数字内容',
        description: '数字产品和内容的订阅付费解决方案'
      }
    ]
  },
  cta: {
    title: '准备开始了吗？',
    subtitle: '立即联系我们，获取专属的支付解决方案',
    button: '联系我们'
  }
};

export default home;
